export default __webpack_public_path__ + "static/media/halloween-1-badge.4b39598a.webp";